module.exports = __webpack_public_path__ + "static/media/bEarthpng.68a9d379.png";